<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">

        <a-form-item label="模板名称">
            <a-input v-model="searchP.templatename" placeholder="模板名称"></a-input>
        </a-form-item>

        <a-form-item label="状态">
            <a-select v-model="searchP.applystatus" placeholder="" style="width: 120px">
                <a-select-option value=""> 全部 </a-select-option>
                <a-select-option value="V3.0"> 审核中 </a-select-option>
                <a-select-option value="V5.0"> 审核通过 </a-select-option>
                <a-select-option value="V5.0"> 审核失败 </a-select-option>
                <a-select-option value="V5.0"> 待提交审核 </a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="类型">
            <a-select v-model="searchP.templatetype" style="width: 120px">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">验证码</a-select-option>
                <a-select-option value="2">通知短信</a-select-option>
                <a-select-option value="3">推广短信</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="开始时间">
            <a-date-picker v-model="searchP.starttime" :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
                            format="YYYY-MM-DD HH:mm:ss" placeholder="选择开始时间"/>
        </a-form-item>
        <a-form-item label="结束时间">
            <a-date-picker v-model="searchP.endtime" :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
                            format="YYYY-MM-DD HH:mm:ss" placeholder="选择结束时间"/>
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>

export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                templatename:'',
                applystatus:'',
                templatetype:'',
                starttime:'',
                endtime:''
            }
        }
    },
    methods:{
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
      
    },
    mounted(){
        this.handleSubmit();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

